import { NavigateBefore, NavigateNext } from '@mui/icons-material';
import AvTimerIcon from '@mui/icons-material/AvTimer';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CloseIcon from '@mui/icons-material/Close';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import QuestionMarkOutlinedIcon from '@mui/icons-material/QuestionMarkOutlined';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import {
  Backdrop,
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  Drawer,
  Grid,
  IconButton,
  Skeleton,
  Tooltip,
  useMediaQuery,
} from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { format } from 'date-fns';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { therapyPlanningTemplate } from 'src/config';
import useFeatureToggle from 'src/hooks/use-feature-toggle';
import { ignoreGroup } from 'src/layouts/components/utils-method';
import { paths } from 'src/paths';
import {
  getPatientIdAction,
  resetSelectPatient,
  selectPatient,
  switchTherapistDisciplineAction,
} from 'src/redux/actions/patientAction';
import {
  getAuthorizationDetails,
  getDischargeDatesOfTherapyPlanning2_0,
  getPatientDateOfService,
  getPlanOfCare,
  getTherapyPlanningPatient_2_0,
  resetGetAllTherapyTemplates,
  resetGetTherapyPlanningPatient_2_0,
} from 'src/redux/actions/therapyPlanning';
import patientListIcon from '../../icons/untitled-ui/duocolor/patientListIcon.svg';
import { BootstrapDialog } from '../common-modals/BootstrapDialog';
import { DotIcon, ManageTemplIcon, PlanOfCareIcon } from './commonComponent/therapy-planning-icons';
import TherapPlanningLoadingPage from './commonComponent/therapy-planning-loading-page';
import TherapyPlaningNavigation from './therapy-planing-navigation';
import { TherapyPlanningPatientList } from './therapy-planing-patient-list-2.0';
import ManageTherapyPlanningTemplate from './therapy-planning-manage-template';

const { therapyPlanning, patients, patientDetails, episodeOfCare, details } = paths;

const tabs = [
  { label: 'Therapy Planning', value: 'info' },
  { label: 'MDS Assessment', value: 'details' },
  {
    label: 'Authorizations',
    value: 'authorization',
  },
];

const TherapyPlanningDetails_2_0 = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [therapyTemplatesEnabled] = useFeatureToggle(therapyPlanningTemplate, 'ENTERPRISE');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [multipleMdsAssessment, setMultipleMdsAssessment] = useState({
    open: [],
    closed: [],
  });

  const [openManageTempDialog, setManageTempDialog] = useState(false);

  const [firstRender, setFirstRender] = useState(true);
  const patientResponse_2_0 = useSelector(
    (state: any) => state.getTherapyPlanningPatientReducer_2_0
  );
  const authDetails = useSelector(
    (state: any) => state.getAuthorizationDetailsReducer?.response?.data
  );
  const updateTherapyPlanningResponse = useSelector(
    (state: any) => state?.updateTherapyPlanningReducer
  );

  const getTherapistProfile = useSelector(
    (state: any) => state.getTherapistProfileReducer?.response?.data
  );
  const getMultipleMdsAssessment = useSelector((state: any) => state.getMultipleMDSAssessment);
  const selectedPatient = useSelector((state: any) => state?.selectPatientReducer?.patientInfo);
  const planOfCareDetails = useSelector(
    (state: any) => state?.getPlanOfCareReducer?.response?.data
  );
  const planOfCareResponse = useSelector((state: any) => state?.getPlanOfCareReducer);
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [searchTerm, setSearchTerm] = useState<string>(state?.searchData ? state?.searchData : '');
  const isTabletScreen = useMediaQuery((theme: any) => theme.breakpoints.down('xl'));

  const onClose = () => {
    setOpen(false);
  };
  const patientId = state?.patientId;

  useEffect(() => {
    if (getMultipleMdsAssessment?.response?.data?.length) {
      const getOpenEoc = getMultipleMdsAssessment?.response?.data?.filter(
        (mds: any) => mds?.status === 'OPENED'
      );
      const getClosed = getMultipleMdsAssessment?.response?.data?.filter(
        (mds: any) => mds?.status === 'CLOSED'
      );
      setMultipleMdsAssessment((prev) => ({
        ...prev,
        open: getOpenEoc,
        closed: getClosed,
      }));
    }
  }, [getMultipleMdsAssessment]);

  useEffect(() => {
    if (selectedPatient) {
      dispatch(getPlanOfCare({ patientId: selectedPatient?.uuid }));
      //get latest discharge dates
      dispatch(
        getDischargeDatesOfTherapyPlanning2_0({
          patientId: selectedPatient?.uuid,
        })
      );
    }
  }, [selectedPatient]);
  useEffect(() => {
    if (selectedPatient?.uuid) {
      dispatch(
        getAuthorizationDetails({
          patientId: selectedPatient?.uuid,
        })
      );
      dispatch(
        getPatientDateOfService({
          patientId: selectedPatient?.uuid,
        })
      );
    }
  }, [selectedPatient?.uuid]);
  const mdsAssessmentResponse = useSelector((state: any) => state?.getMDSAssessmentReducer);
  const mdsAssessmentDetails = useSelector(
    (state: any) => state?.getMDSAssessmentReducer?.response?.data
  );

  const renderFrequencyDuration = (
    disipline: 'OT' | 'SLP' | 'PT',
    source: 'frequency' | 'duration'
  ) => {
    return (
      <Stack
        // gap="1rem"
        alignItems="center"
        flexDirection="row"
        position={'relative'}
        title={source}
      >
        <Chip
          variant="outlined"
          label={disipline}
        />
        <Box
          ml={8}
          position={'absolute'}
        >
          {source === 'frequency' ? <CalendarMonthIcon /> : <AvTimerIcon />}
        </Box>
        <Typography
          position={'absolute'}
          ml={15}
          variant="body2"
        >
          {source === 'frequency'
            ? planOfCareDetails?.disciplineMap[disipline] || '-'
            : planOfCareDetails?.durationMap[disipline] || '-'}
        </Typography>
      </Stack>
    );
  };

  const renderCertDate = (disipline: 'pt' | 'ot' | 'slp') => {
    const startKey = `${disipline}CertStartDate`;
    const endKey = `${disipline}CertEndDate`;

    return (
      <Stack
        alignItems="center"
        flexDirection="row"
        position={'relative'}
      >
        <Chip
          variant="outlined"
          label={disipline?.toUpperCase()}
        />
        <Typography
          variant="body2"
          position={'absolute'}
          ml={15}
        >
          {planOfCareDetails?.[startKey]
            ? format(
                new Date(
                  new Date(planOfCareDetails?.[startKey]).valueOf() +
                    new Date(planOfCareDetails?.[startKey]).getTimezoneOffset() * 60 * 1000
                ),
                'MMM dd, yyyy'
              )
            : '-'}
        </Typography>
        <Typography
          variant="body2"
          position={'relative'}
          ml={30}
        >
          {planOfCareDetails?.[endKey]
            ? format(
                new Date(
                  new Date(planOfCareDetails?.[endKey]).valueOf() +
                    new Date(planOfCareDetails?.[endKey]).getTimezoneOffset() * 60 * 1000
                ),
                'MMM dd, yyyy'
              )
            : '-'}
        </Typography>
      </Stack>
    );
  };

  useEffect(() => {
    return () => {
      if (!location.pathname.startsWith(therapyPlanning.index)) {
        dispatch(resetSelectPatient());
      }
    };
  }, []);

  useEffect(() => {
    const debounceSearch = _.debounce(() => {
      dispatch(resetGetTherapyPlanningPatient_2_0());
      dispatch(
        getTherapyPlanningPatient_2_0({
          params: {
            search: searchTerm,
            page: 0,
            pageSize: 20,
          },
          isFirstTimeCall: firstRender,
        })
      );
    }, 1000);

    if (!state?.flag) debounceSearch();
    setFirstRender(false);

    return () => debounceSearch.cancel();
  }, [searchTerm]);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => prevIndex + 1);
    dispatch(selectPatient(patientResponse_2_0?.totalPatient[currentIndex + 1]));
    if (
      currentIndex + 5 >= patientResponse_2_0?.totalPatient?.length &&
      patientResponse_2_0?.response?.data?.totalElements !==
        patientResponse_2_0?.totalPatient?.length &&
      !patientResponse_2_0?.loading
    ) {
      dispatch(
        getTherapyPlanningPatient_2_0({
          params: {
            search: '',
            page: patientResponse_2_0?.pageNumber,
            pageSize: 20,
          },
          isFirstTimeCall: false,
        })
      );
    }
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) => prevIndex - 1);
    dispatch(selectPatient(patientResponse_2_0?.totalPatient[currentIndex - 1]));
  };

  return (
    <>
      <Container maxWidth="xl">
        <Stack
          spacing={3}
          mt={1}
        >
          <Stack spacing={3}>
            <Grid
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography variant="h4">Therapy Planning</Typography>
                <Box>
                  {patientResponse_2_0?.loading ? (
                    <Box sx={{ width: 100, ml: 3 }}>
                      <Typography
                        width={'100%'}
                        variant="h4"
                      >
                        <Skeleton animation="pulse" />
                      </Typography>
                    </Box>
                  ) : (
                    <Chip
                      label={`${
                        patientResponse_2_0?.response?.data?.totalElements
                          ? patientResponse_2_0?.response?.data?.totalElements
                          : '0'
                      } Patients`}
                      variant="outlined"
                      sx={{ marginLeft: '10px', border: '1px solid  rgba(0, 0, 0, 0.26)' }}
                    />
                  )}
                </Box>
                <Box>
                  <TherapyPlanningPatientList
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    selectedPatient={selectedPatient}
                    setCurrentIndex={setCurrentIndex}
                  />
                </Box>
              </Box>

              {getTherapistProfile?.currentRoles?.includes('dor') && therapyTemplatesEnabled ? (
                <Button
                  variant="text"
                  startIcon={<ManageTemplIcon />}
                  sx={{
                    color: '#6366F1',
                    margin: '0px',
                    padding: '0px',
                    paddingBottom: '2px',
                    cursor: 'pointer',
                    borderRadius: 'unset',
                    backgroundColor: 'transparent',
                    width: 'fit-content',
                  }}
                  onClick={() => {
                    dispatch(resetGetAllTherapyTemplates());
                    setManageTempDialog(true);
                  }}
                >
                  Manage Templates
                </Button>
              ) : null}
            </Grid>
            <Divider sx={{ border: '1px solid #E5E7EB' }} />

            {!selectedPatient?.uuid && patientResponse_2_0?.loading ? (
              <TherapPlanningLoadingPage />
            ) : (
              <Stack
                flexDirection="row"
                gap="1rem"
                sx={{ margin: '0px !important', overflow: 'auto' }}
              >
                {selectedPatient ? (
                  <Stack sx={{ flex: '8', paddingTop: '1.5rem', minWidth: '675px' }}>
                    <Stack
                      flexDirection="row"
                      justifyContent="space-between"
                      mb={1}
                    >
                      <Stack
                        gap="1rem"
                        alignItems="center"
                        flexDirection="row"
                      >
                        <Stack
                          gap="1rem"
                          alignItems="center"
                          flexDirection="row"
                        >
                          <IconButton
                            sx={{
                              width: '32px',
                              height: '32px',
                              padding: '10px',
                              borderRadius: '8px',
                              border: '1px solid #F1F1F1',
                              background: 'rgba(99, 102, 241, 0.10)',
                              '&:hover': {
                                background: 'rgba(99, 102, 241, 0.10)',
                              },
                            }}
                            disabled={!patientResponse_2_0?.totalPatient[currentIndex - 1]?.uuid}
                            onClick={handlePrevious}
                          >
                            <NavigateBefore sx={{ color: '#6366F1', fontSize: '14px' }} />
                          </IconButton>
                          <Stack
                            gap="1rem"
                            alignItems="center"
                            flexDirection="row"
                          >
                            <Avatar
                              src={`data:image/png;base64,${selectedPatient?.profileImage}`}
                              sx={{ textTransform: 'uppercase !important' }}
                            >{`${selectedPatient?.lastName?.at(0) || ''}${
                              selectedPatient?.firstName?.at(0) || ''
                            }`}</Avatar>
                            <Stack gap=".3rem">
                              <Typography
                                sx={{
                                  '&:hover': {
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                  },
                                }}
                                onClick={(event) => {
                                  if (selectedPatient?.eocId && selectedPatient?.uuid) {
                                    dispatch(getPatientIdAction(selectedPatient?.uuid));
                                    dispatch(
                                      switchTherapistDisciplineAction(
                                        getTherapistProfile?.discipline
                                      )
                                    );
                                    navigate(
                                      `${patients}/${patientDetails}${episodeOfCare}${details}`,
                                      {
                                        state: {
                                          episodeOfCareId: selectedPatient?.eocId,
                                          getPatientId: selectedPatient?.uuid,
                                        },
                                      }
                                    );
                                  }
                                }}
                                variant="h5"
                              >
                                {`${selectedPatient?.lastName || ''} ${
                                  selectedPatient?.firstName || ''
                                }`}
                                {/* {selectedPatient?.name} */}
                              </Typography>
                              <Stack
                                flexDirection={'row'}
                                alignItems={'center'}
                                justifyContent={'flex-start'}
                                flexWrap={'nowrap'}
                                gap={1}
                                sx={{
                                  // width: '240px',
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                  textOverflow: 'ellipsis',
                                }}
                              >
                                <Tooltip
                                  title={
                                    selectedPatient?.payerPlanName
                                      ? selectedPatient?.payerPlanName
                                      : null
                                  }
                                >
                                  <Typography
                                    sx={{ display: 'flex', gap: '6px' }}
                                    variant="captionText"
                                  >
                                    <img
                                      alt=""
                                      src={patientListIcon}
                                    />
                                    {selectedPatient?.payerPlanName
                                      ? selectedPatient?.payerPlanName?.length > 10
                                        ? `${selectedPatient?.payerPlanName?.slice(0, 10)}...`
                                        : selectedPatient?.payerPlanName
                                      : '-'}
                                  </Typography>
                                </Tooltip>
                                <DotIcon />
                                <Typography variant="captionText">
                                  {' '}
                                  {selectedPatient?.planTracking
                                    ? selectedPatient?.planTracking
                                    : 'Non - PDPM'}{' '}
                                </Typography>
                              </Stack>
                            </Stack>
                          </Stack>
                          <IconButton
                            onClick={handleNext}
                            disabled={!patientResponse_2_0?.totalPatient[currentIndex + 1]?.uuid}
                            sx={{
                              width: '32px',
                              height: '32px',
                              padding: '10px',
                              borderRadius: '8px',
                              border: '1px solid #F1F1F1',
                              background: 'rgba(99, 102, 241, 0.10)',
                              '&:hover': {
                                background: 'rgba(99, 102, 241, 0.10)',
                              },
                            }}
                          >
                            <NavigateNext sx={{ color: '#6366F1', fontSize: '14px' }} />
                          </IconButton>
                        </Stack>
                        <Divider
                          sx={{
                            background: '#D4D4D4',
                            width: '2px',
                            height: '40px',
                          }}
                          orientation="vertical"
                        />
                        <Stack
                          gap="1rem"
                          alignItems="center"
                          flexDirection="row"
                        >
                          <Tabs
                            indicatorColor="primary"
                            scrollButtons="auto"
                            sx={{
                              // mt: 3,
                              '& .MuiTabs-flexContainer': {
                                gap: '.5rem',
                              },
                            }}
                            textColor="primary"
                            onChange={(event, value) => {
                              value === 'details'
                                ? navigate(`${therapyPlanning.index}${therapyPlanning.details}`, {
                                    state: { patientId },
                                  })
                                : value === 'info'
                                ? navigate(
                                    `${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.info}`,
                                    {
                                      state: { patientId },
                                    }
                                  )
                                : value === 'authorization'
                                ? navigate(
                                    `${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.authorization}`,
                                    {
                                      state: { patientId },
                                    }
                                  )
                                : '';
                            }}
                            variant="scrollable"
                            value={
                              location.pathname ===
                              `${therapyPlanning.index}${therapyPlanning.details}`
                                ? 'details'
                                : location.pathname ===
                                  `${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.info}`
                                ? 'info'
                                : location.pathname ===
                                  `${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.authorization}`
                                ? 'authorization'
                                : ''
                            }
                          >
                            {tabs.map((tab, index) => (
                              <Tab
                                key={index}
                                sx={{ minHeight: '50px' }}
                                disabled={
                                  (!(
                                    selectedPatient?.isMdsPresent ||
                                    multipleMdsAssessment.closed?.length ||
                                    (multipleMdsAssessment.open[0] as any)?.mdsAssessments?.length
                                  ) &&
                                    tab?.value === 'info' &&
                                    selectedPatient?.planTracking === 'PDPM') ||
                                  (tab?.value === 'authorization' &&
                                    !selectedPatient?.isAuthorized) ||
                                  (tab?.value === 'info' && selectedPatient?.isNonTherapy)
                                }
                                label={<Typography variant="subtitle2"> {tab.label} </Typography>}
                                value={tab.value}
                                icon={
                                  index === 1
                                    ? !(
                                        selectedPatient?.isMdsPresent ||
                                        multipleMdsAssessment.closed?.length ||
                                        (multipleMdsAssessment.open[0] as any)?.mdsAssessments
                                          ?.length
                                      ) &&
                                      selectedPatient?.planTracking === 'PDPM' &&
                                      ((
                                        <Tooltip
                                          title="MDS Assessment is required to start the therapy planning"
                                          placement="bottom-end"
                                        >
                                          <IconButton
                                            sx={{
                                              backgroundColor: '#FEE4E2',
                                              padding: '4px',
                                              '&:hover': {
                                                backgroundColor: '#FEE4E2',
                                              },
                                            }}
                                          >
                                            <PriorityHighIcon
                                              sx={{ color: '#B42318', fontSize: '1rem' }}
                                            />
                                          </IconButton>
                                        </Tooltip>
                                      ) as any)
                                    : tab?.value === 'authorization' &&
                                      selectedPatient?.isAuthorized &&
                                      !authDetails?.uuid && (
                                        <IconButton
                                          sx={{
                                            backgroundColor: '#FEE4E2',
                                            padding: '4px',
                                            '&:hover': {
                                              backgroundColor: '#FEE4E2',
                                            },
                                          }}
                                        >
                                          <QuestionMarkOutlinedIcon
                                            sx={{ color: '#B42318', fontSize: '1rem' }}
                                          />
                                        </IconButton>
                                      )
                                }
                                iconPosition="end"
                              />
                            ))}
                          </Tabs>
                        </Stack>
                        {location.pathname?.split('/').pop() === 'info' && !isTabletScreen && (
                          <TherapyPlaningNavigation />
                        )}
                      </Stack>
                      <Button
                        sx={{ height: 'max-content', padding: '6px 14px', gap: '.5rem' }}
                        variant="outlined"
                        size="small"
                        onClick={() => setOpen(true)}
                        startIcon={<PlanOfCareIcon />}
                      >
                        Plan of Care
                      </Button>
                    </Stack>
                    {isTabletScreen && (
                      <Stack
                        mt={'.1rem'}
                        alignItems={'center'}
                      >
                        {location.pathname?.split('/').pop() === 'info' && (
                          <TherapyPlaningNavigation />
                        )}
                      </Stack>
                    )}

                    <Outlet />
                  </Stack>
                ) : (
                  <Box sx={{ flex: '8', paddingTop: '1.5rem', minWidth: '675px', height: '80vh' }}>
                    <Typography variant="h5">No patient record found</Typography>
                  </Box>
                )}
              </Stack>
            )}
          </Stack>
        </Stack>
      </Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme: any) => theme.zIndex.drawer + 1 }}
        open={updateTherapyPlanningResponse?.loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Drawer
        anchor="right"
        onClose={onClose}
        open={open}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: 500,
          },
        }}
      >
        <Stack>
          <Stack
            justifyContent="space-between"
            sx={{ margin: '1.5rem' }}
            flexDirection="row"
          >
            <Typography variant="h5">{`${selectedPatient?.lastName} ${selectedPatient?.firstName}'s Plan of Care`}</Typography>
            <IconButton onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <Divider />
          {/* //new Code */}
          <Stack
            flex={5}
            gap="1.5rem"
          >
            <Card sx={{ padding: '1.5rem' }}>
              <Typography
                sx={{ fontSize: '18px !important' }}
                variant="customHeading"
              >
                Patient Details
              </Typography>
              {!planOfCareResponse?.loading && (
                <Stack
                  sx={{ marginTop: '1rem' }}
                  gap="1rem"
                >
                  <Stack gap=".5rem">
                    <Typography
                      sx={{ marginTop: '1rem' }}
                      variant="subtitle2"
                    >
                      Eval Disciplines
                    </Typography>
                    <Stack
                      flexDirection="row"
                      gap="1rem"
                    >
                      {planOfCareDetails?.evalDisciplines
                        ?.split(',')
                        ?.map((details: any, index: number) => (
                          <Chip
                            key={index}
                            sx={{
                              backgroundColor: '#F3F4F6',
                              color: '#111927',
                              borderRadius: '12px',
                            }}
                            label={details}
                          />
                        ))}
                      {(planOfCareDetails?.evalDisciplines?.split(',')?.length === 0 ||
                        !planOfCareDetails?.evalDisciplines) && <Typography>-</Typography>}
                    </Stack>
                  </Stack>
                  <Stack gap=".5rem">
                    <Typography variant="subtitle2">ICD Codes</Typography>
                    <Stack
                      gap="1rem"
                      flexDirection="row"
                      flexWrap="wrap"
                    >
                      {mdsAssessmentDetails?.icdCodes?.map((icdCode: any, index: number) => (
                        <Tooltip
                          key={index}
                          placement="bottom-end"
                          title="Represents the issues related to Pain in any of the knees."
                        >
                          <Chip
                            variant="outlined"
                            label={`${icdCode} | ${mdsAssessmentDetails?.icdCodesDescription[
                              icdCode?.split(' ')?.at(0)
                            ]}`}
                            sx={{
                              border: '1px solid #00000042',
                              fontSize: '13px',
                              color: '#111927',
                            }}
                          />
                        </Tooltip>
                      ))}
                      {(mdsAssessmentDetails?.icdCodes?.length === 0 ||
                        mdsAssessmentDetails?.icdCodes === undefined) && <Typography>-</Typography>}
                    </Stack>
                  </Stack>
                  <Stack>
                    <Typography variant="subtitle2">Module</Typography>
                    <Typography variant="caption2Text">
                      {mdsAssessmentDetails?.module || '-'}
                    </Typography>
                  </Stack>
                  <Stack>
                    <Typography variant="subtitle2">Payer Type</Typography>
                    <Typography variant="caption2Text">
                      {mdsAssessmentDetails?.payerType || '-'}
                    </Typography>
                  </Stack>
                </Stack>
              )}
              {mdsAssessmentResponse?.loading && (
                <Stack
                  sx={{ marginTop: '2rem' }}
                  gap="1.5rem"
                >
                  <Skeleton
                    height={20}
                    variant="rounded"
                  />
                  <Skeleton
                    variant="rounded"
                    height={20}
                    animation="wave"
                  />
                  <Skeleton
                    variant="rounded"
                    height={20}
                    animation={false}
                  />
                  <Skeleton
                    variant="rounded"
                    height={20}
                    animation={false}
                  />
                  <Skeleton
                    variant="rounded"
                    height={20}
                    animation={false}
                  />
                  <Skeleton
                    variant="rounded"
                    height={20}
                    animation={false}
                  />
                  <Skeleton
                    variant="rounded"
                    height={20}
                    animation={false}
                  />
                  <Skeleton
                    variant="rounded"
                    height={20}
                    animation={false}
                  />
                </Stack>
              )}
            </Card>
          </Stack>

          {!planOfCareResponse?.loading && (
            <Stack
              gap="1rem"
              sx={{ margin: '1.3rem' }}
            >
              <Stack gap=".75rem">
                <Typography
                  variant="paragraphHeading"
                  color="primary"
                >
                  Certifications
                </Typography>
                <Stack
                  alignItems="center"
                  flexDirection="row"
                  position={'relative'}
                  mb={1}
                >
                  <Typography
                    variant="body2"
                    mr={15}
                    position={'absolute'}
                    sx={{ color: '#6C737F' }}
                  >
                    {'Discipline'}
                  </Typography>
                  <Typography
                    variant="body2"
                    ml={15}
                    position={'absolute'}
                    sx={{ color: '#6C737F' }}
                  >
                    {'Start Date'}
                  </Typography>
                  <Typography
                    variant="body2"
                    ml={35}
                    position={'absolute'}
                    sx={{ color: '#6C737F' }}
                  >
                    {'End Date'}
                  </Typography>
                </Stack>
                <Divider />
                <Stack
                  flexWrap="wrap"
                  gap="1rem"
                  flexDirection="column"
                >
                  {renderCertDate('pt')}
                  {renderCertDate('ot')}
                  {renderCertDate('slp')}
                </Stack>
              </Stack>
              <Stack gap=".75rem"> <Divider />
                <Typography
                  variant="paragraphHeading"
                  color="primary"
                >
                  DIAGNOSIS
                </Typography>
                {/* <Stack
                 flexWrap="wrap"
                 gap="1rem"
                 flexDirection="row"
               >
                 {planOfCareDetails?.diagnosis?.map((name: any, index: any) => (
                   <>
                     <Typography variant="body1">{name}</Typography>
                     {index != planOfCareDetails?.diagnosis?.length - 1 && (
                       <Typography variant="body1">,</Typography>
                     )}
                   </>
                 ))}
               </Stack> */}
              </Stack>
              <Divider />
              {renderFrequencyDuration('PT', 'frequency')}
              {renderFrequencyDuration('OT', 'frequency')}
              {renderFrequencyDuration('SLP', 'frequency')}
              <Divider />
              {renderFrequencyDuration('PT', 'duration')}
              {renderFrequencyDuration('OT', 'duration')}
              {renderFrequencyDuration('SLP', 'duration')}
              <Divider />
              <Stack
                flexDirection="row"
                gap="1rem"
              >
                <Box
                  sx={{
                    width: '35px',
                    height: '35px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#e8edff',
                    borderRadius: '12px',
                  }}
                >
                  <WorkspacePremiumOutlinedIcon />
                </Box>
                <Stack>
                  <Typography variant="body2">Goals</Typography>
                  {planOfCareDetails?.goals?.map((goal: any, index: any) => (
                    <Typography
                      key={index}
                      variant="body2"
                    >
                      {goal}
                    </Typography>
                  ))}
                </Stack>
              </Stack>
              <Divider />
              <Stack
                flexDirection="row"
                gap="1rem"
              >
                <Box
                  sx={{
                    width: '35px',
                    height: '35px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#e8edff',
                    borderRadius: '12px',
                  }}
                >
                  <WorkspacePremiumOutlinedIcon />
                </Box>
                <Stack gap=".5rem">
                  <Typography variant="body2">Codes</Typography>
                  <Stack
                    gap="1rem"
                    flexDirection="row"
                    flexWrap={'wrap'}
                  >
                    {planOfCareDetails?.codes?.map((planOfCare: any, index: number) => (
                      <Chip
                        variant="outlined"
                        key={index}
                        label={`${planOfCare} | ${
                          planOfCareDetails?.cptCodeDescription[
                            planOfCare?.includes('(Group)') ? ignoreGroup(planOfCare) : planOfCare
                          ] || ''
                        }`}
                      />
                    ))}
                  </Stack>
                </Stack>
              </Stack>
              <Divider />

              {
                <Stack gap=".5rem">
                  <Stack
                    gap=".5rem"
                    flexDirection="row"
                  >
                    <Typography variant="subtitle2">Concurrent Therapy : </Typography>
                    <Typography variant="body2">
                      {planOfCareDetails?.allowConcurrentTherapy ? 'Allow' : 'Not Allowed'}
                    </Typography>
                  </Stack>
                  <Stack
                    gap="1rem"
                    flexDirection="row"
                  >
                    <Typography variant="subtitle2">Group Therapy : </Typography>
                    <Typography variant="body2">
                      {planOfCareDetails?.allowGroupTherapy ? 'Allow' : 'Not Allowed'}
                    </Typography>
                  </Stack>
                </Stack>
              }
            </Stack>
          )}
          {planOfCareResponse?.loading && (
            <Stack
              sx={{ marginTop: '2rem' }}
              gap="1.5rem"
            >
              <Skeleton
                height={30}
                variant="rounded"
              />
              <Skeleton
                variant="rounded"
                height={30}
                animation="wave"
              />
              <Skeleton
                variant="rounded"
                height={30}
                animation={false}
              />
              <Skeleton
                variant="rounded"
                height={30}
                animation={false}
              />
              <Skeleton
                variant="rounded"
                height={30}
                animation={false}
              />
              <Skeleton
                variant="rounded"
                height={30}
                animation={false}
              />
              <Skeleton
                variant="rounded"
                height={30}
                animation={false}
              />
              <Skeleton
                variant="rounded"
                height={30}
                animation={false}
              />
            </Stack>
          )}
        </Stack>
      </Drawer>
      <BootstrapDialog
        PaperProps={{ style: { maxWidth: '1183px' } }}
        onClose={() => setManageTempDialog(false)}
        aria-labelledby="customized-dialog-title"
        open={openManageTempDialog}
        fullWidth
      >
        <ManageTherapyPlanningTemplate close={() => setManageTempDialog(false)} />
      </BootstrapDialog>
    </>
  );
};

export default TherapyPlanningDetails_2_0;
